(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-news"] && !Shopify.designMode) return;
  try {
    
class FeaturedNewsSlider {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-slider-track]');
    this.slides = container.querySelectorAll('[data-slide]');
    this.prevButton = container.querySelector('[data-prev]');
    this.nextButton = container.querySelector('[data-next]');
    this.dots = container.querySelectorAll('[data-dot]');
    this.autoRotate = container.dataset.autoRotate === 'true';
    this.slideInterval = parseInt(container.dataset.slideInterval) || 5000;
    this.currentSlide = 0;
    this.slideCount = this.slides.length;
    this.autoRotateTimer = null;
    this.isAnimating = false;

    this.init();
  }

  init() {
    if (this.slideCount <= 1) return;

    this.bindEvents();
    if (this.autoRotate) {
      this.startAutoRotate();
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.prevSlide();
        }
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.nextSlide();
        }
      });
    }
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        if (!this.isAnimating) {
          const index = parseInt(dot.dataset.dot);
          this.goToSlide(index);
        }
      });
    });

    this.container.addEventListener('mouseenter', () => this.stopAutoRotate());
    this.container.addEventListener('mouseleave', () => {
      if (this.autoRotate) {
        this.startAutoRotate();
      }
    });

    // Touch events
    let touchStartX = 0;
    let touchEndX = 0;

    this.track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }

  handleSwipe(startX, endX) {
    const diff = startX - endX;
    if (Math.abs(diff) > 50 && !this.isAnimating) { // Minimum swipe distance
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }
  }

  goToSlide(index) {
    if (this.isAnimating) return;
    this.isAnimating = true;
    
    const currentSlide = this.slides[this.currentSlide];
    
    // Determine the next slide index
    let nextIndex = index;
    if (nextIndex >= this.slideCount) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = this.slideCount - 1;
    }
    
    // If it's the same slide, do nothing
    if (nextIndex === this.currentSlide) {
      this.isAnimating = false;
      return;
    }
    
    const nextSlide = this.slides[nextIndex];
    
    // Update dots
    if (this.dots.length > 0) {
      this.dots[this.currentSlide].classList.remove('is-selected');
      this.dots[nextIndex].classList.add('is-selected');
    }
    
    // Prepare next slide for animation
    nextSlide.classList.add('is-animating-in');
    nextSlide.style.display = 'block';
    nextSlide.style.opacity = '0';
    
    // Animate current slide out
    currentSlide.classList.add('is-animating-out');
    
    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(() => {
      // Start animation
      currentSlide.style.opacity = '0';
      nextSlide.style.opacity = '1';
      
      // After animation completes
      setTimeout(() => {
        // Clean up
        currentSlide.classList.remove('is-selected', 'is-animating-out');
        currentSlide.style.opacity = '';
        currentSlide.style.display = '';
        
        nextSlide.classList.remove('is-animating-in');
        nextSlide.classList.add('is-selected');
        nextSlide.style.opacity = '';
        
        // Update current slide index
        this.currentSlide = nextIndex;
        this.isAnimating = false;
      }, 500); // Match this with the CSS transition duration
    });
  }

  nextSlide() {
    this.goToSlide(this.currentSlide + 1);
  }

  prevSlide() {
    this.goToSlide(this.currentSlide - 1);
  }

  startAutoRotate() {
    this.stopAutoRotate();
    this.autoRotateTimer = setInterval(() => {
      if (!this.isAnimating) {
        this.nextSlide();
      }
    }, this.slideInterval);
  }

  stopAutoRotate() {
    if (this.autoRotateTimer) {
      clearInterval(this.autoRotateTimer);
      this.autoRotateTimer = null;
    }
  }
}

// Initialize all sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-slider]');
  sliders.forEach(slider => new FeaturedNewsSlider(slider));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-release"] && !Shopify.designMode) return;
  try {
    
class PressReleases {
  constructor(container) {
    this.container = container;
    this.pressButtons = container.querySelectorAll('[data-press-popup]');
    this.popups = container.querySelectorAll('.press-popup');
    this.closeButtons = container.querySelectorAll('.press-popup-close');
    this.viewAllButton = container.querySelector('[data-view-all-button]');
    this.viewAllContainer = container.querySelector('[data-view-all-container]');
    this.pressList = container.querySelector('[data-press-list]');
    this.pressItems = container.querySelectorAll('[data-press-item]');
    this.hiddenItems = container.querySelectorAll('.press-item--hidden');
    
    this.init();
  }

  init() {
    // Popup functionality
    this.pressButtons.forEach(button => {
      button.addEventListener('click', this.openPopup.bind(this));
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.closePopup.bind(this));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllPopups();
      }
    });

    this.popups.forEach(popup => {
      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          this.closePopup({ target: popup.querySelector('.press-popup-close') });
        }
      });
    });

    // View All functionality
    if (this.viewAllButton) {
      this.viewAllButton.addEventListener('click', this.showAllItems.bind(this));
    }
    
    // Process any content with numbered lists
    this.processNumberedLists();
  }
  
  processNumberedLists() {
    // Find content that might have manual numbering
    const formattedContents = document.querySelectorAll('.press-formatted-content');
    
    formattedContents.forEach(content => {
      // Convert text with number patterns to proper lists
      const text = content.innerHTML;
      
      // Look for patterns like "1. Item" or "1) Item"
      const listPattern = /(\d+[\.\)]\s+.*?)(?=<br>|$)/g;
      
      if (listPattern.test(text)) {
        // It's likely a list, convert it
        const listItems = text.match(listPattern);
        
        if (listItems && listItems.length > 0) {
          let listHtml = '<ol class="press-numbered-list">';
          
          listItems.forEach(item => {
            // Remove the number and punctuation
            const cleanItem = item.replace(/^\d+[\.\)]\s+/, '');
            listHtml += `<li>${cleanItem}</li>`;
          });
          
          listHtml += '</ol>';
          
          // Replace the original content with the formatted list
          content.innerHTML = text.replace(
            new RegExp(listItems.join('(?:<br>|$)').replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g'), 
            listHtml
          );
        }
      }
    });
  }

  openPopup(event) {
    const button = event.target.closest('[data-press-popup]');
    const popupId = button.getAttribute('data-press-popup');
    const popup = document.getElementById(`press-popup-${popupId}`);
    
    if (popup) {
      // Move popup to body to avoid inheritance issues
      document.body.appendChild(popup);
      
      popup.removeAttribute('hidden');
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      
      // Focus the close button
      const closeButton = popup.querySelector('.press-popup-close');
      if (closeButton) {
        setTimeout(() => {
          closeButton.focus();
        }, 100);
      }
    }
  }

  closePopup(event) {
    const closeButton = event.target;
    const popup = closeButton.closest('.press-popup');
    const popupId = popup.id.replace('press-popup-', '');
    const button = this.container.querySelector(`[data-press-popup="${popupId}"]`);
    
    popup.setAttribute('hidden', '');
    button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    
    // Return focus to the button that opened the popup
    button.focus();
  }

  closeAllPopups() {
    this.popups.forEach(popup => {
      if (!popup.hasAttribute('hidden')) {
        const popupId = popup.id.replace('press-popup-', '');
        const button = this.container.querySelector(`[data-press-popup="${popupId}"]`);
        
        popup.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  showAllItems(event) {
    // Show all hidden items with a staggered animation
    this.hiddenItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.remove('press-item--hidden');
        item.classList.add('press-item--revealing');
        
        // Remove the animation class after animation completes
        setTimeout(() => {
          item.classList.remove('press-item--revealing');
        }, 500);
      }, index * 100); // Stagger the animations
    });

    // Hide the View All button after a delay
    setTimeout(() => {
      if (this.viewAllContainer) {
        this.viewAllContainer.classList.add('view-all-press--hidden');
        
        // Remove from DOM after animation completes
        setTimeout(() => {
          this.viewAllContainer.remove();
        }, 300);
      }
    }, this.hiddenItems.length * 100 + 200);

    // Update ARIA attributes
    this.viewAllButton.setAttribute('aria-expanded', 'true');
  }
}

// Initialize all press release sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="press-releases-"]');
  sections.forEach(section => new PressReleases(section));
});

  } catch(e) { console.error(e); }
})();
})();
